import { combineReducers } from "redux";
import siteSettingsReducer from "src/reducers/siteReducer";

export default combineReducers({
  site: siteSettingsReducer,
});
